import { BarChartIcon, BorderWidthIcon } from '@radix-ui/react-icons';
import { Flex, Tabs, Text, Tooltip } from '@raystack/apsara';
import { Bar, Cell } from 'recharts';

import BarGraph from '@src/components/Custom/BarGraph';
import styles from '@src/components/Custom/ModelCommonComponents/styles.module.css';
import { For } from '@src/hoc';

import AreaPercentageTable from './AreaPercentageTable';
import CustomToolTipBarGraph from './CustomTooltipBarGraph';
import CustomTooltipStackedGraph from './CustomTooltipStackedGraph';

const GraphSection = ({ activeGraph, stackGraph }) => {
  const TABS = {
    CHANGE: {
      id: 'area-change',
      value: 'area-change',
      label: 'Class wise area change chart',
      icon: <BarChartIcon />,
      content: (
        <BarGraph
          data={activeGraph}
          tooltipProps={{ content: <CustomToolTipBarGraph /> }}
          axis={{
            x: { key: 'class' },
            y: { key: 'difference', label: 'Area Change (in %)' }
          }}
        >
          <Bar dataKey='difference'>
            {activeGraph.map((bar, index) => (
              <Cell key={index} fill={bar.color} />
            ))}
          </Bar>
        </BarGraph>
      )
    },
    DISTRIBUTION: {
      id: 'area-distrbution',
      value: 'area-distrbution',
      label: 'Class wise area distrbution chart',
      icon: <BorderWidthIcon />,
      content: (
        <BarGraph
          data={stackGraph}
          tooltipProps={{ content: <CustomTooltipStackedGraph /> }}
          axis={{
            x: { key: 'name' },
            y: { label: 'Class Distribution (in %)' }
          }}
        >
          {activeGraph.map((item, i) => {
            return (
              <Bar
                key={i}
                stackId='class-distribution'
                dataKey={item.class}
                fill={item.color}
              ></Bar>
            );
          })}
        </BarGraph>
      )
    }
  };

  return (
    <>
      <Tabs defaultValue={TABS.CHANGE.value}>
        <Flex
          style={{ width: '100%', marginBottom: 'var(--rs-space-8)' }}
          justify='between'
          align='center'
        >
          <Flex
            style={{ width: '100%' }}
            justify='start'
            align='baseline'
            gap='small'
          >
            <Text weight={500} size={4}>
              Class wise statistics
            </Text>
            <Text weight={500} size={1} variant='tertiary'>
              (Comparison - Reference)
            </Text>
          </Flex>
          <Tabs.List className={styles.tabsList}>
            <For each={[...Object.entries(TABS)]}>
              {([key, tab]) => (
                <Tooltip key={key} side='top' message={tab.label}>
                  <Tabs.Trigger
                    icon={tab.icon}
                    value={tab.value}
                  ></Tabs.Trigger>
                </Tooltip>
              )}
            </For>
          </Tabs.List>
        </Flex>
        <For each={[...Object.entries(TABS)]}>
          {([key, tab]) => (
            <Tabs.Content key={key} value={tab.value}>
              {tab.content}
            </Tabs.Content>
          )}
        </For>
      </Tabs>

      <AreaPercentageTable data={activeGraph} />
    </>
  );
};
export default GraphSection;
